import { LOCAL_STORAGE_KEY, nyushoGridConfig, tsushoGridConfig } from '@core/configs';
import { normalizeSettingHeaders, NormalizeSettingHeadersOptions } from '@core/helper';

type PrepareHeaderFunction = (header: any) => any;

export interface CheckSheetTvSettingOptions {
    isNyuSho: boolean;
    defaultNyuShoDisplayConfig: any;
    defaultSortConfig: any;
    prepareHeader: PrepareHeaderFunction;
}

export function getCheckSheetSetting(settingData: any, options: CheckSheetTvSettingOptions): any {
    const mergedHeaders = mergeCheckSheetHeaders(settingData?.[LOCAL_STORAGE_KEY.settingDialogHeaders], options);
    

    const checkSheetSetting = {
        ...settingData,
        headers: mergedHeaders.headers,
        ...(!options.isNyuSho? { sortConfig: settingData?.sortConfig ?? options.defaultSortConfig }: {}),
        ...(options.isNyuSho ? { nyuShoDisplayConfig: settingData?.nyuShoDisplayConfig ?? options.defaultNyuShoDisplayConfig } : {}),
    };

    return checkSheetSetting;
}

function mergeCheckSheetHeaders(headers: any[], options: CheckSheetTvSettingOptions): any {
    const option : NormalizeSettingHeadersOptions = {
            excludedFields: ['index'],
            prepareHeader: options.prepareHeader,
    };
    return normalizeSettingHeaders(
        options.isNyuSho ? nyushoGridConfig.header : addReasonLeaveHeader(tsushoGridConfig.header),
        headers,
        option
    );
}

function addReasonLeaveHeader(headers: any[]): any[] {
    if (headers?.some((header: any) => header?.field === 'leave_reason')) return headers;
    return [
        ...headers,
        {
            field: 'leave_reason',
            headerName: '中止理由',
            visible: true,
        },
    ];
}
